/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeslotDisplay } from './TimeslotDisplay';
import {
    TimeslotDisplayFromJSON,
    TimeslotDisplayFromJSONTyped,
    TimeslotDisplayToJSON,
} from './TimeslotDisplay';

/**
 * 
 * @export
 * @interface Timeslot
 */
export interface Timeslot {
    /**
     * 
     * @type {TimeslotDisplay}
     * @memberof Timeslot
     */
    display: TimeslotDisplay;
    /**
     * 
     * @type {string}
     * @memberof Timeslot
     */
    bookableId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Timeslot
     */
    id: string;
}

/**
 * Check if a given object implements the Timeslot interface.
 */
export function instanceOfTimeslot(value: object): value is Timeslot {
    if (!('display' in value) || value['display'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TimeslotFromJSON(json: any): Timeslot {
    return TimeslotFromJSONTyped(json, false);
}

export function TimeslotFromJSONTyped(json: any, ignoreDiscriminator: boolean): Timeslot {
    if (json == null) {
        return json;
    }
    return {
        
        'display': TimeslotDisplayFromJSON(json['display']),
        'bookableId': json['bookableId'] == null ? undefined : json['bookableId'],
        'id': json['id'],
    };
}

export function TimeslotToJSON(value?: Timeslot | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'display': TimeslotDisplayToJSON(value['display']),
        'bookableId': value['bookableId'],
        'id': value['id'],
    };
}

